import { Button, Form, Tooltip } from "antd";
import ButtonWrapper from "components/shared-components/MaterialFormUI/Button";
import InputField from "components/shared-components/MaterialFormUI/InputContainer";
import CustomizedDialogs from "components/shared-components/messagenotification/successmessage";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { MdEdit, MdPerson } from "react-icons/md";
import { useDispatch } from "react-redux";
import { logout } from "redux/reducers/loggedInUser";
import { updatemanageUserRequest } from "redux/reducers/manageUsers";
import ConvertIamgeToBase64 from "utils/convertImage";
import * as Yup from "yup";
import moment from "moment-timezone";
import { env } from 'configs/EnvironmentConfig';
const envVersion = env.APP_VERSION;
const contentEditableStyle = {
  outline: "none",
  borderBottom: "1px solid #000",
};

const FORM_VALIDATION = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  emailId: Yup.string(),
  mobile: Yup.string().required("required"),
});
const PersonStyle = { color: "#ffffff", textAlign: "center", margin: "25px" };

const MyAccount = (props, { parentCallback }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isReadonly, setIsReadonly] = useState(true);
  const [userData, setUserData] = useState(false);
  useEffect(() => {
    if (props.data !== undefined) {
      setUserData(props?.data);
    }
  }, []);
  const INITIAL_FORM_STATE = {
    firstName: userData?.firstName,
    mobile: userData?.mobile,
    address: userData?.address,
    timeZone: moment
      .tz(userData?.createdDate, "Asia/Singapore")
      .format(),
    dataLocation: "Singapore",
  };
  const handleclose = () => {
    setIsModalVisible(false);
  };
  const handleCancelMOdal = () => {
    props.parentCallback(false);
    setIsModalVisible(false);
  };
  const onlogoutClick = () => {
    dispatch(logout());
  };
  return (
    <>
      <div style={{ margin: "-15px" }}>
        <div className="myaccount-wrapper">
          <Formik
            initialValues={{ ...INITIAL_FORM_STATE }}
            enableReinitialize
            validationSchema={FORM_VALIDATION}
            onSubmit={(values) => {
              props.parentCallback(false);
              setIsModalVisible(true);
              setIsReadonly(false);

              dispatch(
                updatemanageUserRequest({
                  _id: userData._id,
                  ...values,
                })
              );
            }}
          >
            {({ errors, touched, values, setFieldValue }) => {
              return (
                <Form>
                  <div className="account-info-wrapper">
                    <div className="row pop-group-fields g-0">
                      <div
                        className="col-4"
                        style={{ marginTop: "10px", paddingRight: "0px" }}
                      >
                        {userData.profilePicture === undefined ? (
                          <div
                            className="rounded-circle mx-2"
                            style={{
                              backgroundColor: "#ced1d9",
                              width: "85px",
                              height: "85px",
                            }}
                          >
                            <MdPerson size={35} style={PersonStyle} />
                          </div>
                        ) : (
                          <img
                            src={userData?.profilePicture}
                            className="rounded-circle mx-2"
                            style={{
                              backgroundColor: "#ced1d9",
                              height: "85px",
                              width: "85px",
                            }}
                            alt
                          />
                        )}
                        <div className="profilePhoto">
                          <ConvertIamgeToBase64 />
                        </div>
                      </div>
                      <div className="col-8" style={{ paddingLeft: "0px" }}>
                        <table className="account-info account-info-top">
                          <tr>
                            <td>
                              {isReadonly ? (
                                <p className="namee mb-0">
                                  {userData?.firstName} {userData?.lastName}
                                </p>
                              ) : (
                                <div>
                                  <InputField
                                    errors={errors.firstName}
                                    touched={touched.firstName}
                                    values={values.firstName}
                                    name="firstName"
                                    placeholder=""
                                    required={true}
                                  ></InputField>
                                </div>
                              )}
                            </td>
                            <td>
                              <a
                                onClick={() => {
                                  setIsReadonly(!isReadonly);
                                }}
                              >
                                <Tooltip title="Edit">
                                  <MdEdit
                                    className="edit-account-info"
                                    size={16}
                                  />
                                </Tooltip>
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p style={{ marginBottom: "0px" }}>
                                {userData?.email}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            {isReadonly ? (
                              <td>
                                <p>{userData?.mobile}</p>
                              </td>
                            ) : (
                              <div>
                                <InputField
                                  errors={errors.mobile}
                                  touched={touched.mobile}
                                  values={values.mobile}
                                  name="mobile"
                                  placeholder=""
                                  required={true}
                                ></InputField>
                              </div>
                            )}
                          </tr>
                        </table>
                      </div>
                    </div>
                    <div className="account-info pt-2">
                      <table>
                        <tr>
                          <td width="35%" style={{ color: "#838a9b" }}>
                            City:
                          </td>
                          <td>{userData?.city?.name}</td>
                        </tr>
                        <tr>
                          <td style={{ color: "#838a9b" }}>Address:</td>
                          <td>
                            {isReadonly ? (
                              <p className="mb-0">{userData?.address}</p>
                            ) : (
                              <div>
                                <InputField
                                  errors={errors.address}
                                  touched={touched.address}
                                  values={values.address}
                                  name="address"
                                  placeholder=""
                                  required={true}
                                ></InputField>
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ color: "#838a9b" }}>Office:</td>
                          <td>{userData?.primaryLocation?.name}</td>
                        </tr>
                        <tr>
                          <td style={{ color: "#838a9b" }}>Time Zone:</td>
                          <td>{values?.timeZone}</td>
                        </tr>
                        <tr>
                          <td style={{ color: "#838a9b" }}>Data Location:</td>
                          <td>{values?.dataLocation}</td>
                        </tr>
                      </table>
                      {!isReadonly ? (
                        <div>
                          <ButtonWrapper
                            className="btn btn-primary btn-small"
                            type="submit"
                          >
                            Update
                          </ButtonWrapper>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div style={{ margin: "0 10px" }}>
                    <div className="Repeat-Grid-17 ">Release : <b>{envVersion}</b></div>
                    <div className="Line-224"></div>
                    <div className="Repeat-Grid-17 ">
                      <a
                        href={
                          "https://www.smartworksoffice.com/terms-conditions/"
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        Terms and Conditions
                      </a>
                    </div>
                    <div className="Line-224"></div>
                    <div className="Repeat-Grid-17 ">
                      <a
                        href={
                          "https://www.smartworksoffice.com/privacy-policy/"
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        End User License
                      </a>
                    </div>
                    <div className="Line-224"></div>
                    <div className="Repeat-Grid-17 ">
                      <a role="button" onClick={onlogoutClick}>
                        Logout
                      </a>
                    </div>
                    <div className="Line-224"></div>
                  </div>
                  <div className="form-footer">
                    <button
                      className="btn btn-ghost"
                      onClick={handleCancelMOdal}
                    >
                      Close
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <CustomizedDialogs
          isModalVisible={isModalVisible}
          handleOkModal={handleclose}
          handleCancelMOdal={handleclose}
          message={"Account has been updated."}
          info={"Thank you"}
        />
      </div>
    </>
  );
};

export default MyAccount;
